<!-- Start Slider Area -->
<!-- <div class="slider-area slider-pad">
    <div class="home-slider owl-carousel owl-theme">
        <div class="slider-item bg-item1">
            <div class="container">
                <div class="slider-content">
                    
                    <h1>{{ formValues.bannerHeader1 }}</h1>
                    <p>{{ formValues.bannerContent1 }}</p>
                    <p>{{ formValues.bannerContent_1 }}</p>

                    <div class="slider-btn">
                        <a routerLink="/spekwo-products" [queryParams]="{ product: 'full' }" class="get-btn">Request Quote</a>
                    </div>
                    
                </div>
            </div>
        </div>

        
    </div>
</div> -->
<!-- Slider Area End -->


<!-- <div class="about-area pb-0 pt-45">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-img">
                    <img src="assets/img/home-one/purpose-1.jpg" alt="Images">

                    <div class="about-img-shape">
                        <div class="shape-1"><img src="assets/img/about/shape1.png" alt="Images"></div>
                        <div class="shape-2"><img src="assets/img/about/shape2.png" alt="Images"></div>
                        <div class="shape-3"><img src="assets/img/about/shape2.png" alt="Images"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <div class="section-title">
                        <h2>{{ formValues.purposeHeader }}</h2>
                        <p>{{ formValues.purposeContent }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<!-- <div class="service-area pb-0">
    <div class="container">
        <div class="service-slider owl-carousel owl-theme pt-45">
            <div class="service-item">
                <a class="service-icon">
                    <i class='bx bx-phone'></i>
                </a>
                <h3><a routerLink="#">{{ formValues.justTalkHeader }}</a></h3>
                <p>{{ formValues.justTalkContent }}</p>
            </div>
            <div class="service-item">
                <a class="service-icon">
                    <i class='bx bx-map'></i>
                </a>
                <h3><a>{{ formValues.spotOnHeader }}</a></h3>
                <p>{{ formValues.spotOnContent }}</p>
            </div>
            <div class="service-item">
                <a class="service-icon">
                    <i class='bx bxs-chat'></i>
                </a>
                <h3><a>{{ formValues.jonesHeader }}</a></h3>
                <p>{{ formValues.jonesContent }}</p>
            </div>
            
        </div>
    </div>
</div> -->

<!-- <div class="section-title text-center text-pad">
    <h2>{{ formValues.spekwoThought }}</h2>
</div> -->

<!-- Start Slider Area -->
<!-- <div class="slider-area  slider-pad">
    <div class="home-slider owl-carousel owl-theme">
        <div class="slider-item bg-item4">
            <div class="container">
                <div class="slider-content">
                    <div class="">
                        <div>
                            <h1 class="sli-head">{{ formValues.quotesTitle }}</h1>
                            <p class="sli-head-sub">{{ formValues.quoteSubTitle }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Slider Area End -->

<!-- Start Slider Area -->
<!-- <div class="slider-area slider-pad">
    <div class="home-slider owl-carousel owl-theme">
        <div class="slider-item bg-item5">
            <div class="container">
                <div class="slider-content">
                    <div class="content-left">
                        <div>
                            <h1 class="sli-head">{{ formValues.repairTitle }}</h1>
                            <p class="sli-head-sub">{{ formValues.repairSubTitle }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Slider Area End -->

<!-- <div class="project-area pt-45 pb-45">
    <div class="container">
        <div class="tab project-tab">
            <div class="tab_content current active pt-45">
                <div class="tabs_item current active">
                    <div class="project-tab-item">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="#">
                                        <img src="assets/img/home-one/home-page-bottom-of-screen-first-pic.png"
                                            alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="#">{{ formValues.hoverContent1 }}</a></h3>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="#">
                                        <img src="assets/img/home-one/home-page-bottom-of-screen-center-pic.png"
                                            alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="#">{{ formValues.hoverContent2 }}</a></h3>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div class="project-card">
                                    <a routerLink="#">
                                        <img src="assets/img/home-one/home-page-bottom-of-screen-final-pic.jpg"
                                            alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="#">{{ formValues.hoverContent3 }}</a></h3>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="about-area  pb-45">
    <div class="container">
        <app-testimonial></app-testimonial>
    </div>
</div> -->


<!-- <app-spekwo-served-images></app-spekwo-served-images> -->

<!-- Start Choose Area -->
<!-- <div class="choose-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Why Choose Us?</span>
            <h2>We Have the Plan for You to Give You Best </h2>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-sm-6">
                <div class="choose-card">
                    <div class="choose-icon one-bg">
                        <i class='bx bx-help-circle'></i>
                    </div>

                    <div class="content">
                        <h3>Problem Solver</h3>
                        <p>We have the best service for you to make and this is one of the best service.</p>
                        <a routerLink="/service-details" class="read-more-btn"><i
                                class="left-icon bx bx-right-arrow-alt"></i> Read More <i
                                class="right-icon bx bx-right-arrow-alt"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="choose-card">
                    <div class="choose-icon two-bg">
                        <i class='bx bx-time'></i>
                    </div>

                    <div class="content">
                        <h3>On-time Deliveries</h3>
                        <p>We have the best service for you to make and this is one of the best service.</p>
                        <a routerLink="/service-details" class="read-more-btn"><i
                                class="left-icon bx bx-right-arrow-alt"></i> Read More <i
                                class="right-icon bx bx-right-arrow-alt"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 offset-lg-0 offset-sm-3">
                <div class="choose-card">
                    <div class="choose-icon three-bg">
                        <i class='bx bx-bulb'></i>
                    </div>

                    <div class="content">
                        <h3>Services by Experts</h3>
                        <p>We have the best service for you to make and this is one of the best service.</p>
                        <a routerLink="/service-details" class="read-more-btn"><i
                                class="left-icon bx bx-right-arrow-alt"></i> Read More <i
                                class="right-icon bx bx-right-arrow-alt"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Choose Area End -->

<!-- Start About Area -->
<!-- <div class="about-area pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-img">
                    <img src="assets/img/about/about-img1.jpg" alt="Images">

                    <div class="about-img-shape">
                        <div class="shape-1"><img src="assets/img/about/shape1.png" alt="Images"></div>
                        <div class="shape-2"><img src="assets/img/about/shape2.png" alt="Images"></div>
                        <div class="shape-3"><img src="assets/img/about/shape2.png" alt="Images"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <div class="section-title">
                        <span>About Us</span>
                        <h2>We Have 20+ Years of Service Experience for You</h2>
                        <p>We have a lots of plan to make a good and best & one of the most modern car for you. We have
                            a good experience and a good image on the global sector.</p>
                    </div>

                    <ul>
                        <li><i class='bx bx-check-circle'></i> Customer Satisfaction</li>
                        <li><i class='bx bx-check-circle'></i> Latest & Modern Shop</li>
                        <li><i class='bx bx-check-circle'></i> Expertise Diagnostics</li>
                        <li><i class='bx bx-check-circle'></i> Fair Pricing</li>
                        <li><i class='bx bx-check-circle'></i> Expert Care</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- About Area End -->

<!-- Start Service Area -->
<!-- <div class="service-area pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Services</span>
            <h2>We Always Ready to Serve You the Best Service</h2>
            <p>We have a good expert in the global market and this will help us to make a good image on our service
                market and globally.</p>
        </div>

        <div class="service-slider owl-carousel owl-theme pt-45">
            <div class="service-item">
                <a routerLink="/service-details" class="service-icon">
                    <i class='flaticon-wheel'></i>
                </a>
                <h3><a routerLink="/service-details">Wheel Adjustment</a></h3>
                <p>We are always help to make one of the best adjustment service for us and all the details.</p>
                <a routerLink="/service-details" class="read-more-btn"><i class="left-icon bx bx-right-arrow-alt"></i>
                    Read More <i class="right-icon bx bx-right-arrow-alt"></i></a>
            </div>

            <div class="service-item">
                <a routerLink="/service-details" class="service-icon">
                    <i class='flaticon-settings'></i>
                </a>
                <h3><a routerLink="/service-details">Engine Servicing</a></h3>
                <p>We are always help to make one of the best adjustment service for us and all the details.</p>
                <a routerLink="/service-details" class="read-more-btn"><i class="left-icon bx bx-right-arrow-alt"></i>
                    Read More <i class="right-icon bx bx-right-arrow-alt"></i></a>
            </div>

            <div class="service-item">
                <a routerLink="/service-details" class="service-icon">
                    <i class='flaticon-fan'></i>
                </a>
                <h3><a routerLink="/service-details">Cooling Servicing</a></h3>
                <p>We are always help to make one of the best adjustment service for us and all the details.</p>
                <a routerLink="/service-details" class="read-more-btn"><i class="left-icon bx bx-right-arrow-alt"></i>
                    Read More <i class="right-icon bx bx-right-arrow-alt"></i></a>
            </div>

            <div class="service-item">
                <a routerLink="/service-details" class="service-icon">
                    <i class='flaticon-service'></i>
                </a>
                <h3><a routerLink="/service-details">Engine Repair</a></h3>
                <p>We are always help to make one of the best adjustment service for us and all the details.</p>
                <a routerLink="/service-details" class="read-more-btn"><i class="left-icon bx bx-right-arrow-alt"></i>
                    Read More <i class="right-icon bx bx-right-arrow-alt"></i></a>
            </div>
        </div>
    </div>
</div> -->
<!-- Service Area End -->

<!-- Start Pricing Area -->
<!-- <div class="pricing-area pricing-bg pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Pricing Plan</span>
            <h2>We Are Always Ready to Give You the Best Price Benefits</h2>
            <p>We have a good expert in the global market and this will help us to make a good image on our service
                market and globally.</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="pricing-card">
                    <div class="pricing-card-into color-bg1">
                        <i class="bx bx-paper-plane pricing-icon color-1"></i>
                        <h3 class="color-1">STANDARD</h3>

                        <div class="price-rate">
                            <h2 class="color-1">$ 69.99</h2>
                            <span class="color-1">Weekly Package</span>
                        </div>

                        <ul>
                            <li><i class='bx bx-check'></i> Weekly Servicing Policy.</li>
                            <li><i class='bx bx-check'></i> Replacement Guarantee</li>
                            <li><i class='bx bx-check'></i> Unlimited Servicing.</li>
                            <li><del>Unlimited Parts Replacement.</del></li>
                            <li><del>Unlimited Membership.</del></li>
                        </ul>

                        <a routerLink="/" class="purchase-btn">PURCHASE NOW</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="pricing-card">
                    <div class="pricing-card-into color-bg2">
                        <i class="bx bx-paper-plane pricing-icon color-2"></i>
                        <h3 class="color-2">ECONOMY</h3>

                        <div class="price-rate">
                            <h2 class="color-2">$ 79.99</h2>
                            <span class="color-2">Monthly Package</span>
                        </div>

                        <ul>
                            <li><i class='bx bx-check'></i>Monthly Servicing Policy.</li>
                            <li><i class='bx bx-check'></i>Replacement Guarantee</li>
                            <li><i class='bx bx-check'></i>Unlimited Servicing.</li>
                            <li><i class='bx bx-check'></i>Unlimited Parts Replacement</li>
                            <li><del>Unlimited Membership.</del></li>
                        </ul>

                        <a routerLink="/" class="purchase-btn">PURCHASE NOW</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                <div class="pricing-card">
                    <div class="pricing-card-into color-bg3">
                        <i class="bx bx-paper-plane pricing-icon color-3"></i>
                        <h3 class="color-3">EXECUTIVE</h3>

                        <div class="price-rate">
                            <h2 class="color-3">$ 89.99</h2>
                            <span class="color-3">Yearly Package</span>
                        </div>

                        <ul>
                            <li><i class='bx bx-check'></i>Yearly Servicing Policy.</li>
                            <li><i class='bx bx-check'></i>Replacement Guarantee</li>
                            <li><i class='bx bx-check'></i>Unlimited Servicing.</li>
                            <li><i class='bx bx-check'></i>Unlimited Parts Replacement</li>
                            <li><i class='bx bx-check'></i>Unlimited Membership</li>
                        </ul>

                        <a routerLink="/" class="purchase-btn">PURCHASE NOW</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Pricing Area End -->

<!-- Start Achievements Area -->
<!-- <div class="achievements-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Achievements</span>
            <h2>We Are Always Famous for Our All Achievements</h2>
            <p>This is one of the best way to make a good achievements into the global world and this is really helpful
                for you.</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-3 col-sm-6">
                <div class="achievements-card achievements-bg-1">
                    <i class="flaticon-rating"></i>
                    <h3>120K+</h3>
                    <span>Dedicated Clients</span>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="achievements-card achievements-bg-2">
                    <i class="flaticon-service"></i>
                    <h3>200K+</h3>
                    <span>Car Repair</span>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="achievements-card achievements-bg-3">
                    <i class="flaticon-user"></i>
                    <h3>170+</h3>
                    <span>Dedicated Experts</span>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="achievements-card achievements-bg-4">
                    <i class="flaticon-calendar"></i>
                    <h3>70+</h3>
                    <span>Years Experience</span>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Achievements Area End -->

<!-- Start Project Area -->
<!-- <div class="project-area pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="project-title">
                    <div class="section-title">
                        <span>Our Projects</span>
                        <h2>Some Of Our Projects Work Where We Helped</h2>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="project-text">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla et amet bibendum ante. Vestibulum
                        ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae pellentesque.</p>
                </div>
            </div>
        </div>

        <div class="tab project-tab">
            <ul class="tabs">
                <li><a href="#">Wheels</a></li>
                <li><a href="#">Steering</a></li>
                <li><a href="#">Brakes</a></li>
                <li><a href="#">Suspension</a></li>
                <li><a href="#">Tyre</a></li>
            </ul>

            <div class="tab_content current active pt-45">
                <div class="tabs_item current active">
                    <div class="project-tab-item">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img2.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Wheels</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img1.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Steering</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img3.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Tyre</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="project-tab-item">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img4.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Steering</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img5.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Brakes</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img6.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Tyre</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="project-tab-item">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img2.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Brakes</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img3.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Suspension</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img6.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Tyre</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="project-tab-item">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img3.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Suspension</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img2.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Brakes</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img4.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Steering</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="project-tab-item">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img4.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Steering</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img5.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Brakes</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div class="project-card">
                                    <a routerLink="/projects-details">
                                        <img src="assets/img/project/project-img6.jpg" alt="Images">
                                    </a>
                                    <div class="project-content">
                                        <h3><a routerLink="/projects-details">Tyre</a></h3>
                                        <div class="content">
                                            <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed
                                                varius nisl libero, at tempor lectus mollis.</p>
                                            <a routerLink="/projects-details" class="project-more">Read More</a>
                                        </div>
                                        <div class="project-card-bottom"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Project Area End -->

<!-- Start Testimonials Area -->
<!-- <div class="testimonials-area testimonials-bg  pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Testimonials</span>
            <h2>Let's Know About Our Client Says</h2>
        </div>

        <div class="testimonials-slider pt-45 owl-carousel owl-theme">
            <div class="testimonials-item">
                <div class="row align-items-center">
                    <div class="col-lg-7 col-md-6">
                        <div class="testimonials-content">
                            <h3>Devit M. kolin</h3>
                            <span>CEO & Founder</span>
                            <p>Awesome dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationaco
                                laboris nisi ut aliquip commodo consequat.</p>
                        </div>
                    </div>

                    <div class="col-lg-5 col-md-6">
                        <div class="testimonials-img">
                            <img src="assets/img/testimonials/testimonials-img.jpg" alt="Images">

                            <div class="quote-text">
                                <i class='flaticon-left-quote'></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="testimonials-item">
                <div class="row align-items-center">
                    <div class="col-lg-7 col-md-6">
                        <div class="testimonials-content">
                            <h3>Robart D.dondoe</h3>
                            <span>CEO Of Car Company</span>
                            <p>Awesome dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationaco
                                laboris nisi ut aliquip commodo consequat.</p>
                        </div>
                    </div>

                    <div class="col-lg-5 col-md-6">
                        <div class="testimonials-img">
                            <img src="assets/img/testimonials/testimonials-img2.jpg" alt="Images">

                            <div class="quote-text">
                                <i class='bx bxs-quote-left'></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Testimonials Area End -->

<!-- Start Team Area -->
<!-- <div class="team-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Our Team</span>
            <h2>We Have an Expert & Dedicated Team Member</h2>
        </div>

        <div class="team-slider pt-45 owl-carousel owl-theme">
            <div class="team-item">
                <div class="team-img">
                    <img src="assets/img/team/team-img6.jpg" alt="Images">

                    <div class="social-icon">
                        <ul class="social-link">
                            <li><a href="https://www.facebook.com/SpeKwo-344051736111918/" target="_blank"><i
                                        class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>
                </div>

                <div class="content">
                    <h3>John Doe</h3>
                    <span>Founder - CEO</span>
                </div>
            </div>

            <div class="team-item">
                <div class="team-img">
                    <img src="assets/img/team/team-img3.jpg" alt="Images">

                    <div class="social-icon">
                        <ul class="social-link">
                            <li><a href="https://www.facebook.com/SpeKwo-344051736111918/" target="_blank"><i
                                        class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>
                </div>

                <div class="content">
                    <h3>Jenifar Ambrina</h3>
                    <span>Co-Founder</span>
                </div>
            </div>

            <div class="team-item">
                <div class="team-img">
                    <img src="assets/img/team/team-img5.jpg" alt="Images">

                    <div class="social-icon">
                        <ul class="social-link">
                            <li><a href="https://www.facebook.com/SpeKwo-344051736111918/" target="_blank"><i
                                        class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>
                </div>

                <div class="content">
                    <h3>Johan Smith</h3>
                    <span>Manager</span>
                </div>
            </div>

            <div class="team-item">
                <div class="team-img">
                    <img src="assets/img/team/team-img2.jpg" alt="Images">

                    <div class="social-icon">
                        <ul class="social-link">
                            <li><a href="https://www.facebook.com/SpeKwo-344051736111918/" target="_blank"><i
                                        class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        </ul>
                    </div>
                </div>

                <div class="content">
                    <h3>Sendy Alina</h3>
                    <span>Team Leader</span>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Team Area End -->

<!-- Start Blog Area -->
<!-- <div class="blog-area pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>Blogs</span>
            <h2>Latest Blog Post</h2>
            <p>We have more than one year work blog and we have a fantastic blog on the global market. This is really
                helpful for the end user.</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="blog-card">
                    <a routerLink="/blog-details">
                        <img src="assets/img/blog/blog-img1.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <span>January 01, 2020</span>
                        <h3><a routerLink="/blog-details">Modern Technology Has Invested Globally</a></h3>
                        <a routerLink="/blog-details" class="read-more-btn">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="blog-card">
                    <a routerLink="/blog-details">
                        <img src="assets/img/blog/blog-img2.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <span>August 01, 2020</span>
                        <h3><a routerLink="/blog-details">International Car Trade Make a Deal for Us</a></h3>
                        <a routerLink="/blog-details" class="read-more-btn">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="blog-card">
                    <a routerLink="/blog-details">
                        <img src="assets/img/blog/blog-img3.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <span>September 09, 2020</span>
                        <h3><a routerLink="/blog-details">Marketing Policy Added on the Policy Service</a></h3>
                        <a routerLink="/blog-details" class="read-more-btn">Read More</a>
                    </div>
                </div>
            </div>
          -->
<!-- Blog Area End -->

<div class="spekwo-home">

    <!-- ==============================
         MOBILE STICKY CTA
    =============================== -->
    <div class="mobile-sticky-cta" [class.show]="showMobileCta">
        <a href="tel:7046261776" class="mobile-call-btn" aria-label="Call speKwo">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2
                    19.79 19.79 0 0 1-8.63-3.07
                    19.5 19.5 0 0 1-6-6
                    19.79 19.79 0 0 1-3.07-8.67
                    A2 2 0 0 1 4.11 2h3a2 2 0 0 1
                    2 1.72c.13.96.36 1.9.7 2.81
                    a2 2 0 0 1-.45 2.11L8.09 9.91
                    a16 16 0 0 0 6 6l1.27-1.27
                    a2 2 0 0 1 2.11-.45
                    c.9.34 1.85.57 2.81.7
                    A2 2 0 0 1 22 16.92z" />
            </svg>
        </a>

        <a routerLink="/spekwo-products" [queryParams]="{ product: 'full' }" class="mobile-request-btn">
            Request a Quote
            <span>→</span>
        </a>
    </div>


    <!-- ==============================
         SCROLL PROGRESS
    =============================== -->
    <div class="scroll-progress" [style.transform]="'scaleX(' + scrollProgress + ')'"></div>


    <!-- ==============================
         HERO
    =============================== -->
    <section id="top" class="hero-section">

        <!-- Animated background blobs -->
        <div class="hero-blob hero-blob-a"></div>
        <div class="hero-blob hero-blob-b"></div>
        <div class="hero-blob hero-blob-c"></div>
        <div class="hero-blob hero-blob-d"></div>

        <div class="hero-container">

            <!-- Hero Content -->
            <div class="hero-content">

                <div class="hero-badge">
                    <span class="badge-dot"></span>
                    NEUTRAL REPAIR QUOTES · 24–72 HRS
                </div>

                <h1>
                    Keep your
                    <br>
                    deals
                    <span class="hero-highlight">
                        alive.
                        <span class="highlight-line"></span>
                    </span>
                </h1>

                <p class="hero-description">
                    One neutral, consistent repair quote in 72 hours,
                    so negotiations move and you look like the hero.
                    speKwo doesn't just quote the repairs. They fix them,
                    in-house.
                </p>

                <div class="hero-buttons">

                    <a href="javascript:void(0)" (click)="mobileSectionClick('how')" class="secondary-btn">
                        See How It Works
                    </a>

                    <a routerLink="/spekwo-products" [queryParams]="{ product: 'full' }" class="primary-btn">
                        Request a Quote
                        <span>→</span>
                    </a>

                </div>

                <div class="hero-stats">

                    <div class="hero-stat">
                        <div class="stat-value">
                            24–72<span>h</span>
                        </div>

                        <div class="stat-label">
                            TURNAROUND
                        </div>
                    </div>

                    <div class="stat-divider"></div>

                    <div class="hero-stat">
                        <div class="stat-value">
                            7<span>/wk</span>
                        </div>

                        <div class="stat-label">
                            DAYS A WEEK
                        </div>
                    </div>

                    <div class="stat-divider"></div>

                    <div class="hero-stat">
                        <div class="stat-value">
                            100<span>%</span>
                        </div>

                        <div class="stat-label">
                            IN-HOUSE CREWS
                        </div>
                    </div>

                </div>

            </div>


            <!-- Specification Card -->
            <div class="hero-card-wrapper">

                <div class="hero-card-hatch"></div>

                <div class="hero-card-float">

                    <div class="spec-card">

                        <div class="spec-card-header">
                            <span>
                                REPAIR QUOTE · SPEC
                            </span>

                            <span class="spec-badge">
                                REV. 24-72H
                            </span>
                        </div>


                        <div class="spec-list">

                            <div class="spec-row">
                                <span>TURNAROUND</span>
                                <strong>24 to 72 hrs</strong>
                            </div>

                            <div class="spec-row">
                                <span>AVAILABILITY</span>
                                <strong>7 days a week</strong>
                            </div>

                            <div class="spec-row">
                                <span>POSITION</span>
                                <strong class="red-text">
                                    Neutral party
                                </strong>
                            </div>

                            <div class="spec-row last">
                                <span>REPAIRS</span>
                                <strong>In-house crew</strong>
                            </div>

                        </div>


                        <div class="spec-note">
                            Quote → approve → repair.
                            One partner, one number both sides trust.
                        </div>


                        <div class="spec-footer">
                            <span>D W G . 0 0 1</span>
                            <span>C A R O L I N A S</span>
                        </div>

                    </div>

                </div>

            </div>

        </div>


        <!-- ==============================
             TICKER
        =============================== -->
        <div class="ticker">

            <div class="ticker-track">

                <div class="ticker-content">

                    <span>NEUTRAL REPAIR QUOTES</span>
                    <i>✦</i>

                    <span>24 TO 72 HRS</span>
                    <i>✦</i>

                    <span>7 DAYS A WEEK</span>
                    <i>✦</i>

                    <span>IN-HOUSE TRADESMEN</span>
                    <i>✦</i>

                    <span>HONORED AT THE PRICE QUOTED</span>
                    <i>✦</i>

                    <span>SERVING THE CAROLINAS</span>
                    <i>✦</i>

                </div>


                <div class="ticker-content">

                    <span>NEUTRAL REPAIR QUOTES</span>
                    <i>✦</i>

                    <span>24 TO 72 HRS</span>
                    <i>✦</i>

                    <span>7 DAYS A WEEK</span>
                    <i>✦</i>

                    <span>IN-HOUSE TRADESMEN</span>
                    <i>✦</i>

                    <span>HONORED AT THE PRICE QUOTED</span>
                    <i>✦</i>

                    <span>SERVING THE CAROLINAS</span>
                    <i>✦</i>

                </div>

            </div>

        </div>

    </section>


    <!-- ==============================
         THE PROBLEM
    =============================== -->
    <section id="problem" class="section problem-section">

        <div class="section-container">

            <div class="section-label" data-reveal>
                <span>01 / THE PROBLEM</span>
                <i></i>
            </div>


            <h2 class="section-title" data-reveal data-reveal-delay="100">
                Due diligence is where good deals go to
                <span>die.</span>
            </h2>


            <div class="problem-grid">

                <div class="problem-card" data-reveal data-reveal-delay="150">
                    <div class="card-number">
                        P.01
                    </div>

                    <h3>
                        Deals dying in due diligence
                    </h3>

                    <p>
                        One repair dispute stalls the contract
                        and buyers walk before anyone agrees
                        on a number.
                    </p>
                </div>


                <div class="problem-card" data-reveal data-reveal-delay="250">
                    <div class="card-number">
                        P.02
                    </div>

                    <h3>
                        Inconsistent contractor quotes
                    </h3>

                    <p>
                        Three bids, three wildly different totals.
                        Nobody trusts any of them and the
                        negotiation stalls.
                    </p>
                </div>


                <div class="problem-card" data-reveal data-reveal-delay="350">
                    <div class="card-number">
                        P.03
                    </div>

                    <h3>
                        Days lost chasing callbacks
                    </h3>

                    <p>
                        You are stuck playing phone tag with
                        contractors while the clock on the
                        deal runs down.
                    </p>
                </div>


                <div class="problem-card" data-reveal data-reveal-delay="450">
                    <div class="card-number">
                        P.04
                    </div>

                    <h3>
                        Client stress reflects on you
                    </h3>

                    <p>
                        When the process feels chaotic, your
                        clients remember who was steering.
                        That is your reputation.
                    </p>
                </div>

            </div>

        </div>

    </section>


    <!-- ==============================
         HOW IT WORKS
    =============================== -->
    <section id="how" class="section how-section">

        <div class="how-glow"></div>

        <div class="section-container">

            <div class="section-label" data-reveal>
                <span>02 / HOW IT WORKS</span>
                <i></i>
            </div>


            <div class="how-heading" data-reveal data-reveal-delay="100">

                <h2 class="section-title">
                    Three steps.
                    <span>One partner.</span>
                </h2>

                <p>
                    The pricing is neutral by design,
                    favoring neither the buyer nor seller,
                    so both sides trust the number.
                </p>

            </div>


            <div class="steps-grid">

                <div class="step-card" data-reveal data-reveal-delay="150">

                    <div class="step-number red-outline">
                        01
                    </div>

                    <h3>
                        Submit the inspection report
                    </h3>

                    <p>
                        Send speKwo the home-inspection report
                        with the flagged repair and replacement
                        items. That is the whole ask on your end.
                    </p>

                </div>


                <div class="step-card" data-reveal data-reveal-delay="250">

                    <div class="step-number orange-outline">
                        02
                    </div>

                    <h3>
                        Get a neutral quote in 24 to 72 hours
                    </h3>

                    <p>
                        speKwo returns one consistent quote,
                        7 days a week. The pricing favors neither
                        buyer nor seller, so both sides trust
                        the number.
                    </p>

                </div>


                <div class="step-card dark-step-card" data-reveal data-reveal-delay="350">

                    <div class="step-number orange-outline">
                        03
                    </div>

                    <h3>
                        speKwo completes the repairs in-house
                    </h3>

                    <p>
                        Approve the work and speKwo's own
                        full-time tradesmen do the repairs at
                        the price quoted — crawlspace, plumbing,
                        electrical, interior and exterior.
                        One partner, start to finish.
                    </p>

                </div>

            </div>


            <div class="neutral-note" data-reveal data-reveal-delay="450">

                <span class="check-icon">
                    ✓
                </span>

                <strong>
                    Neutral by design.
                </strong>

                <span>
                    speKwo is a true third party. The number
                    isn't padded for the seller or shaved for
                    the buyer. It's simply the cost to do the
                    work right.
                </span>

            </div>

        </div>

    </section>


    <!-- ==============================
         PRICING
    =============================== -->
    <section id="pricing" class="section pricing-section">

        <div class="section-container">

            <div class="section-label" data-reveal>
                <span>03 / PRICING</span>
                <i></i>
            </div>


            <h2 class="section-title" data-reveal data-reveal-delay="100">
                Flat, upfront
                <span>quote pricing.</span>
            </h2>


            <div class="pricing-grid">

                <!-- Full speKwo -->
                <div class="pricing-card featured-card" data-reveal data-reveal-delay="150">

                    <div class="most-complete">
                        MOST COMPLETE
                    </div>

                    <div class="pricing-type">
                        FULL REPORT
                    </div>

                    <h3>
                        The Full speKwo
                    </h3>

                    <div class="price">
                        $89
                        <span>/ quote</span>
                    </div>

                    <p>
                        An estimate for every single item on
                        the home inspection identified as
                        "repair/replace." Best suited for
                        clients who are not sure of cost and
                        need a little intel to assist in their
                        negotiations.
                    </p>

                    <div class="pricing-note">
                        ALL ITEMS QUOTED IN 24–72 HOURS
                    </div>

                    <a routerLink="/spekwo-products" [queryParams]="{ product: 'full' }" class="pricing-primary-btn">
                        Request a Quote
                    </a>

                </div>


                <!-- Itemized -->
                <div class="pricing-card" data-reveal data-reveal-delay="250">

                    <div class="pricing-type red">
                        CLIENT CHOICE
                    </div>

                    <h3>
                        Itemized Solution Estimate
                    </h3>

                    <div class="price">
                        $59
                        <span>/ quote</span>
                    </div>

                    <p>
                        A quote for up to 40 items you choose
                        from your recent home inspection.
                        Best suited for clients who know what
                        items are most important to them, or
                        have already finalized their Due
                        Diligence Request & Agreement.
                    </p>

                    <div class="pricing-note red">
                        ALL ITEMS QUOTED IN 24–72 HOURS
                    </div>

                    <a routerLink="/spekwo-products" [queryParams]="{ product: 'itemized' }"
                        class="pricing-secondary-btn">
                        Request an Itemized Solution
                    </a>

                </div>


                <!-- Prelist -->
                <div class="pricing-card" data-reveal data-reveal-delay="350">

                    <div class="pricing-type red">
                        FOR SELLERS
                    </div>

                    <h3>
                        Pre-List Quote
                    </h3>

                    <div class="price">
                        $59
                        <span>/ quote</span>
                    </div>

                    <p>
                        For clients preparing to go on the market
                        and looking to make the best first
                        impression. Submit 1 to 2 pictures per
                        item with your own correlating description
                        of what you would like done.
                    </p>

                    <div class="pricing-note red">
                        ALL ITEMS QUOTED IN 24–72 HOURS
                    </div>

                    <a routerLink="/spekwo-products" [queryParams]="{ product: 'prelist' }"
                        class="pricing-secondary-btn">
                        Request a Prelist Quote
                    </a>

                </div>

            </div>


            <div class="pricing-notes" data-reveal data-reveal-delay="450">

                <div>
                    <span>✓</span>

                    If speKwo completes the work exceeding
                    $1,500, the quote cost is refunded.
                </div>


                <div>
                    <span>✓</span>

                    All repairs are completed in-house by
                    speKwo's full-time tradesmen.
                </div>


                <div>
                    <span>✓</span>

                    We are so confident in the accuracy of our
                    quote we will complete the repairs for the
                    price quoted.
                </div>

            </div>

        </div>

    </section>


    <!-- ==============================
         REVIEWS
    =============================== -->
    <section id="reviews" class="section reviews-section">

        <div class="section-container">

            <div class="section-label" data-reveal>
                <span>04 / REVIEWS</span>
                <i></i>
            </div>


            <div class="reviews-heading" data-reveal data-reveal-delay="100">

                <h2 class="section-title">
                    What agents
                    <span>say</span>
                </h2>

                <p>
                    Carolina real estate professionals on why
                    speKwo has become part of how they close.
                </p>

            </div>


            <div class="reviews-grid">

                <figure class="review-card" data-reveal data-reveal-delay="150">

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo has helped me buy back precious
                        time in my schedule, at an incredibly low
                        cost. Every quote received has saved me
                        so many hours of time calling and driving
                        to meet contractors. The clients love
                        having a one stop shop for repairs &
                        quotes. If you are a full-time agent, this
                        service is a must, to keep you doing what
                        you do best… selling houses!
                    </blockquote>

                    <figcaption>

                        <img src="https://api.spekwo.com/bannerImages/2/2_Scott%20H.png" alt="Scott H.">

                        <span>
                            SCOTT H. · TRADE & TRYON REALTY
                        </span>

                    </figcaption>

                </figure>


                <figure class="review-card" data-reveal data-reveal-delay="250">

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I always follow up with my clients after
                        they have work completed with your company
                        and I am yet to have any disappointed
                        clients! Your process is easy and convenient
                        to use, which compliments a smooth process
                        for my clients throughout their purchasing
                        process!
                    </blockquote>

                    <figcaption>

                        <img src="https://api.spekwo.com/bannerImages/1/1_Judi%20S.png" alt="Judi S.">

                        <span>
                            JUDI S. · KELLER WILLIAMS BALLANTYNE
                        </span>

                    </figcaption>

                </figure>


                <figure class="review-card" data-reveal data-reveal-delay="350">

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I first learned about spekwo when the
                        buyers' agent presented their quote to
                        negotiate repairs. I was the listing agent
                        in that transaction. Because I constantly
                        deal with repairs and also renovations,
                        I have a pretty good idea of what fair and
                        reasonable contractors charge, and spekwo
                        was exactly that. Since then, I have been
                        using them for my client's deals and highly
                        recommend them.
                    </blockquote>

                    <figcaption>

                        <img src="https://api.spekwo.com/bannerImages/6/6_Claudia%20O.png" alt="Claudia O.">

                        <span>
                            CLAUDIA O. · COMPASS
                        </span>

                    </figcaption>

                </figure>

            </div>


            <div class="reviews-button" data-reveal data-reveal-delay="450">

                <a routerLink="/testimonials">
                    Read all reviews
                    <span>→</span>
                </a>

            </div>

        </div>

    </section>


    <!-- ==============================
         VIDEO
    =============================== -->
    <section id="video" class="video-section">

        <div class="video-container">

            <div class="section-label" data-reveal>
                <span>05 / WATCH</span>
                <i></i>
            </div>


            <div class="video-heading" data-reveal data-reveal-delay="100">

                <h2 class="section-title">
                    See how speKwo
                    <span>works.</span>
                </h2>

                <p>
                    Forty-five seconds on how a neutral repair
                    quote comes together, from inspection report
                    to a number that holds in negotiation.
                </p>

            </div>


            <div class="video-player" data-reveal data-reveal-delay="200" (click)="playVideo()">

                <video #explainerVideo playsinline preload="metadata" poster="assets/img/home-one/explainer-poster.png">

                    <source src="assets/img/home-one/spekwo-explainer.mp4" type="video/mp4" />

                </video>


                <div class="video-overlay" [class.hidden]="videoPlaying">

                    <div class="play-button">

                        <svg width="34" height="34" viewBox="0 0 24 24" fill="#fff">
                            <path d="M8 5v14l11-7z" />
                        </svg>

                    </div>


                    <span class="video-label">
                        WATCH THE 45-SEC EXPLAINER
                    </span>

                </div>

            </div>


            <div class="mobile-video-label">
                WATCH THE 45-SEC EXPLAINER
            </div>

        </div>

    </section>


    <!-- ==============================
         PARTNER PROGRAM
    =============================== -->
    <section id="partner" class="partner-section">

        <div class="section-container">

            <div class="section-label" data-reveal>
                <span>06 / PARTNER PROGRAM</span>
                <i></i>
            </div>


            <div class="partner-heading" data-reveal data-reveal-delay="100">

                <h2 class="section-title">
                    Become a referral
                    <span>partner.</span>
                </h2>

                <p>
                    Give your clients a partner who quotes fair
                    and fixes fast, and stay the agent who kept
                    the deal moving.
                </p>

            </div>

        </div>


        <div class="partner-card" data-reveal data-reveal-delay="150">

            <div class="partner-blob-a"></div>
            <div class="partner-blob-b"></div>


            <div class="partner-grid">

                <div class="partner-content" data-reveal data-reveal-delay="250">

                    <h2>
                        Hand your clients one number
                        <br>
                        both sides trust.
                    </h2>

                    <p>
                        Hand your clients a partner who quotes
                        fair and fixes fast. You keep the deal
                        moving, they get one number both sides
                        trust, and you look like the hero who
                        solved it.
                    </p>


                    <div class="partner-actions">

                        <a routerLink="/contact" class="partner-start-btn">
                            Get Started
                            <span>→</span>
                        </a>


                        <span class="or-text">
                            OR
                        </span>


                        <a href="tel:7046261776" class="partner-call-btn">

                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2
                                    19.79 19.79 0 0 1-8.63-3.07
                                    19.5 19.5 0 0 1-6-6
                                    19.79 19.79 0 0 1-3.07-8.67
                                    A2 2 0 0 1 4.11 2h3a2 2 0 0 1
                                    2 1.72c.13.96.36 1.9.7 2.81
                                    a2 2 0 0 1-.45 2.11L8.09 9.91
                                    a16 16 0 0 0 6 6l1.27-1.27
                                    a2 2 0 0 1 2.11-.45
                                    c.9.34 1.85.57 2.81.7
                                    A2 2 0 0 1 22 16.92z" />
                            </svg>

                            Call 704-626-1776

                        </a>

                    </div>

                </div>


                <div class="promo-card" data-reveal data-reveal-delay="350">

                    <div class="promo-label">
                        YOUR CO-BRANDED PROMO CODE
                    </div>

                    <div class="promo-code">
                        [PROMO CODE]
                    </div>

                    <p>
                        Co-branded with your name, so every quote
                        reminds your client who kept the deal alive.
                    </p>

                </div>

            </div>

        </div>

    </section>

</div>